import ScheduleForm from './components/ScheduleForm/ScheduleForm.css';
import Location from './components/Location/Location.css';
import Value from './components/Value/Value.css';

export default {
	ScheduleForm,
	Location,
	Value
};
